<script setup lang="ts">
import { get } from 'lodash';
import { getOptimizedImageSrc } from '@/directives/optimizedImageSize';
import { IProfile } from '@/interfaces';
import BaseOverlay from '@/overlays/BaseOverlay.vue';

const emit = defineEmits(['close']);

interface Props {
  title: string;
  profiles: IProfile[];
}

withDefaults(defineProps<Props>(), {});

function getDepartmentName(profile: IProfile) {
  return get(profile, 'departments[0].name', '');
}
</script>

<template>
  <BaseOverlay @close="emit('close')" :title="title">
    <template #content>
      <div
        v-for="(profile, index) in profiles"
        :key="index"
        class="participants content inline-flex w-full pb-10"
      >
        <img
          :src="getOptimizedImageSrc(profile.displayImage, 'small')"
          :class="{ '-m-1': index !== 0 }"
          class="w-24 h-24 rounded-full border border-gray-200 mr-10 object-cover"
        />
        <div class="details">
          <p class="label">
            {{ profile.displayName }}
          </p>
          <span>
            <fa-icon :icon="['fal', 'house-user']" />
            {{ getDepartmentName(profile) }}
          </span>
        </div>
      </div>
    </template>
  </BaseOverlay>
</template>
